module.exports = __webpack_public_path__ + "img/wz-3-8.ba6d0bbd.jpg";